import React, { memo, ReactElement, useMemo } from "react";
import cx from "classnames";

import { format } from "@swiggy-private/core-ui";
import { CART_ITEMS_TEST_IDS } from "@swiggy-private/cart-test-ids";

import { ButtonTitles } from "@swiggy-private/cart-types";

import styles from "../styles/FoodItem.scss";

interface ExtraCartItemInlineButtonProps {
    title: ButtonTitles;
    onClick: () => void;
    updating: boolean;
    className?: string;
}

const ACCESSIBLITY_TEXTS = {
    BUTTON: "{0} Offer Bundle",
};

const ExtraCartItemInlineButton = ({ onClick, updating, title }: ExtraCartItemInlineButtonProps): ReactElement => {
    const toggleButtonContainer = useMemo(() => {
        return cx(styles.toggleButtonContainer, styles.toggleButtonContainerCartV2, {
            [styles.toggleButtonContainerAdd]: title === ButtonTitles.ADD,
        });
    }, [title]);
    return (
        <button
            aria-label={format(ACCESSIBLITY_TEXTS.BUTTON, title)}
            className={toggleButtonContainer}
            onClick={onClick}
            data-testid={CART_ITEMS_TEST_IDS.CART_ITEM_TOGGLE_BUTTON}
        >
            {title}

            {updating && <div className={styles.toggleButtonContainerLoader} />}
        </button>
    );
};

export default memo(ExtraCartItemInlineButton);
